import { render } from "./IntersectionObserver.vue?vue&type=template&id=5b57d286&scoped=true"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"

import "./IntersectionObserver.vue?vue&type=style&index=0&id=5b57d286&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b57d286"]])

export default __exports__